import { useSelector, useDispatch } from "react-redux";
import {  removeFilter } from "../../configureStore";
import { forwardRef } from "react";
import {
  setLoading
} from "../../configureStore";
/**
 * Renders a list of pills based on the filters selected by the user.
 * @param {object} props - Component props.
 * @param {React.Ref} ref - Component reference.
 * @returns {JSX.Element} - Rendered component.
 */
const PillsList = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.searchData.filters);

  const pillClicked = (pill, type) => {
    dispatch(removeFilter({id:pill, type}));
    dispatch(setLoading(true));
  };

  const generatePills = () => {
    const arr = [];
    Object.keys(filters).forEach((filter) => {
      const filterType = filters[filter];
      Object.keys(filterType).forEach((pill) => {
        const name = filterType[pill].name;
        arr.push(
          <li key={pill + name}>
            <button
              className="pill"
              id={pill}
              onClick={() => {
                pillClicked(pill, filter);
              }}
            >
              {name}
              <span className="icon icon--16">
                <img
                  loading="lazy"
                  alt="icon"
                  src="/assets/images/close.svg"
                  width="16"
                  height="16"
                />
              </span>
            </button>
          </li>
        );
      });
    });
    return arr;
  };

  return (
    <ul ref={ref} className="pills__list">
      {generatePills()}
    </ul>
  );
});
export default PillsList;